module.exports = __webpack_public_path__ + "img/mianyang.89372f68.jpg";